<template>
	<div>
		<vs-table stripe noDataText="کاربری موجود نیست." :data="usersList">
			
			<template slot="header">
				<vs-button @click="addUser()" class="mb-4">ثبت کاربر جدید</vs-button>
				<div @keydown.enter="search()">
					<vs-input class="w-full searchInput mb-4" v-model="title" placeholder="جستجو..." />
				</div>
			</template>
			
			<template slot="thead">
				<vs-th>	نام و نام خانوادگی </vs-th>
				<vs-th>	موبایل </vs-th>
				<vs-th>	ایمیل </vs-th>
				<vs-th>	تاریخ تولد </vs-th>
				<vs-th> شهر </vs-th>
				<vs-th>  </vs-th>
			</template>

			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td>
						{{data[indextr].name}} {{data[indextr].last_name}}
					</vs-td>

					<vs-td>
						{{data[indextr].phone_number}}
					</vs-td>

					<vs-td>
						{{data[indextr].email}}
					</vs-td>

					<vs-td>
						{{birthDate(data[indextr].birth_date)}}
					</vs-td>
					<vs-td>
						{{data[indextr].city}}
					</vs-td>
					<vs-td class="">
						<feather-icon @click="editUser(data[indextr].id)" icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="mr-4 button-link" />
						<feather-icon @click="deleteUser(data[indextr].name, data[indextr].last_name, data[indextr].id)" icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="button-link" />
            		</vs-td>
				</vs-tr>
				<div class="float-left">
					<vs-pagination class="mt-4" :total="last_page" v-model="table_options.current_page"></vs-pagination>
				</div>
			</template>

		</vs-table>

		<AddUser :popupAddUser='popupAddUser' @updatePopupAddUser='updatePopupAddUser'/>

		<EditUser :popupEditUser='popupEditUser' :userId='editUserId' @updatePopupEditUser='updatePopupEditUser'/>

		<DeleteUser :popupDeleteUser='popupDeleteUser' :userId='deleteUserId' :name='userName' :lastName='userLastName' @updatePopupDeleteUser='updatePopupDeleteUser'/>
	
	</div>
</template>

<script>
import AddUser from './Add'
import EditUser from './Edit'
import DeleteUser from './Delete'

export default {
	components: {
		AddUser,
		EditUser,
		DeleteUser,
	},

	data() {
		return{
			popupAddUser: false,
			popupEditUser: false,
			popupDeleteUser: false,

			editUserId: 0,
			deleteUserId: 0,

			userName: '',
			userLastName: '',

			title: '',
			
            last_page: 0,
			table_options: {
				current_page: 1,
			},
		}
	},

	computed: {
		usersList() {
      		return this.$store.state.users.users
		},
	},

	watch: {
		"table_options.current_page": function () {
			this.getUsers();
		},
	},

	created(){
		this.getUsers();
	},

	methods: {
		birthDate(date){
			if (date === null) {
				return "0000/00/00";
			} else {
				return date.replace(/-/g, "/");
			}
		},

        getUsers(){
			this.$vs.loading()
			let data = {
				title: this.title,
				page: this.table_options.current_page
			}
			this.$store.dispatch('getUsers', data)
			.then((res) => {
				this.last_page = res.data.last_page;
				this.$vs.loading.close()
			}).catch(() => {
				this.$vs.loading.close()
				this.$vs.notify({
					title: '',
					text: 'خطا در اتصال به اینترنت',
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'warning'
				})
			})
		},

		search(){
			this.table_options.current_page = 1
			this.getUsers()
		},

		addUser(){
			this.popupAddUser = true
		},

		editUser(id){
			this.popupEditUser = true
			this.editUserId = id
		},
		
		deleteUser(name, lastName, id){
			this.popupDeleteUser = true
			this.userName = name
			this.userLastName = lastName
			this.deleteUserId = id
		},

        updatePopupAddUser(value){
            this.popupAddUser = value
		},

		updatePopupEditUser(value){
            this.popupEditUser = value
		},
		
		updatePopupDeleteUser(value){
            this.popupDeleteUser = value
        },
  	}
}
</script>

<style>
.center {
    padding: 2.2rem !important;
}
.button-link {
	cursor: pointer;
}
.vs-con-table .vs-con-tbody {
    border: unset !important;
}
</style>